export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN"
export const SET_UPDATE_STEP= "SET_UPDATE_STEP"
export const SET_OFFERS_DATA = "SET_OFFERS_DATA"
export const SET_RAZORPAY_ORDER_ID = "SET_RAZORPAY_ORDER_ID"
export const SET_SUCCESSFULL_RAZORPAY_PAYMENT = "SET_SUCCESSFULL_RAZORPAY_PAYMENT"
export const SET_CUSTOMER_DATA = "SET_CUSTOMER_DATA"
export const SET_DATA_LOADING = "SET_DATA_LOADING"